export const DATADOG_CONTEXT = 'ESIM Transfer';

export const ONE_CLICK_TC_TITLE = 'One-Click Terms & Conditions';
export const ONE_CLICK_TC_EMPTY_BODY =
  'No one-click terms and conditions available for this locale.';
